export const alphanumericRegex = /^[a-z0-9]+$/i;
export const integerAndFloatNumbersRegex = /^\d+(\.\d+)?$/;
export const integerAndFloatNumbersWithNegativesRegex = /^[-+]?\d+(\.\d+)?$/;
export const integerNumbersRegex = /^\d/;
